import { VolumeHighIcon } from './VolumeHighIcon';

/**
 * author: Google
 * id CE6E08CF-2476-4BBB-AF91-6D081F1CBEF9
 * name volume-high
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volume-high.svg
 * tags
 * - Audio 
 * - Home Automation 
 * - Cellphone / Phone 
 */
export const SpeakerphoneIcon = VolumeHighIcon;
export default SpeakerphoneIcon